import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import BannerSlider from "../HomeTwo/BannerSlider";
import SofaSet from "../Home/SofaSet";
import About from "../HomeTwo/About";
import Services from "../Home/Services";
import MetaTags from "react-meta-tags";

const HometwoPage = () => {
  return (
    <>
      <MetaTags>
        <title>Sedačka na každodenné spanie Emma</title>
        <meta name="description" content="Sedačka na každodenné spanie s matracom Emma kombinuje moderný dizajn, vysoký komfort a praktické riešenie pre váš domov. Sofabed Emma vyrobená na Slovensku." />
        <meta property="og:title" content="Sedačka na každodenné spanie Emma" />
        <meta property="og:image" content="assets/Images/banner1.jpg" />
      </MetaTags>
      <Header />
      <BannerSlider />
      <Services />
      <SofaSet />
      <About />
      <Footer />
    </>
  );
};

export default HometwoPage;
